import CardCController from "./CardCController";

export default CardCController;
